import { SubsectionRecord } from '../interfaces/subsection-record.interface';
import { Error, Loading, TopToolbar, useQueryWithStore } from 'react-admin';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import * as React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    justifyContent: 'flex-start',
  },
  backButton: {
    fontSize: '1em',
    textTransform: 'none',
  },
});

export const SubsectionEditActionsToolbar = (props: {
  record: SubsectionRecord;
}) => {
  const record: SubsectionRecord = props.record;

  const { data, loading, error } = useQueryWithStore({
    type: 'getOne',
    resource: 'section',
    payload: { id: record.sectionId },
  });

  const classes = useStyles();

  if (loading) return <Loading />;
  if (error) return <Error />;
  if (!data) return null;

  return (
    <TopToolbar className={classes.root}>
      <Button
        className={classes.backButton}
        component={Link}
        to={'/section/' + record.sectionId}
      >
        <ArrowBackIosIcon /> {data.title} Details
      </Button>
    </TopToolbar>
  );
};
